import React from "react";
import { MantineProvider } from "@mantine/core";
import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";
import { PricingTable } from "../../components/PricingTable/PricingTable";

const theme = {};

const PricingPage = () => {
  return (
    <MantineProvider theme={theme}>
      {Header()}
      {PricingTable()}
      {Footer()}
    </MantineProvider>
  );
};

export default PricingPage;
